import React, { useState, useEffect, useRef} from "react";
import OTPInput from "../../../Components/Forms/OTP/OTPForm";
import { toast } from "react-toastify";
import SkeletonLoading from "../../../Components/Skeleton/SkeletonLoading";

type VerifyEmailTypeDef = {
  onResendOTP: () => void;
  onSubmitOTP: (otp: string) => void;
  isInitialSendCode: boolean;
  loading: boolean;
}

//form-control Error class=> form-control-lg is-invalid
const VerifyEmail: React.FC<VerifyEmailTypeDef> = (props) => {
  const {onResendOTP, onSubmitOTP, isInitialSendCode, loading} = props;
  const [isSendCode, setIsSendCode] = useState<boolean>(false);
  const [seconds, setSeconds] = useState<number>(60);
  const [otp, setOtp] = useState<string>("");
  const [isVerifyReady, setIsVerifyReady] = useState<boolean>(false)
  const btnRef = useRef<any>();

  const onChange = (otps: string) => {
    setOtp(otps)
    setIsVerifyReady((otps.trim()).length < 6 ? false : true);
  };

  useEffect(() => {
    if(isVerifyReady){
      btnRef.current.focus();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVerifyReady])

  const reSendOTP = () => {
      setIsSendCode(true);
      onResendOTP();
  }

  useEffect(() => {
    setIsSendCode(true);
    let countSeconds = seconds;
    let tempTimer: any = 0;
    if (tempTimer === 0 && countSeconds > 0){
        tempTimer = setInterval(()=>{
        countSeconds = countSeconds - 1;
        setSeconds(countSeconds);
            if (countSeconds === 0) {
                clearInterval(tempTimer);
                setIsSendCode(false);
                setSeconds(60);
            }
        },1000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialSendCode]);
  

  const OnClickVerify = () =>{
    if(otp.length === 6){
      onSubmitOTP(otp);
    }else{
      toast.error("Please enter verification code")
    }
  }

  return (
    <>
      <div className="card-inner create-account">
        <div className={`user-detail active verify-otp`}>
            <div className="lable-main mb-2" style={{color: "#66CFC8"}}>
            {loading ? <SkeletonLoading width={160} height={23} />: "Verification Code"}
            </div>
            <div className="mb-4">
              <div className="d-flex align-items-center">
              {loading ? (
                <>
                  <SkeletonLoading width={275} height={46} />
                </>
              ) : (
                <>
                  <OTPInput
                    otpvalue={otp}
                    otplength={6}
                    styleclasses={"form-control"}
                    onChange={onChange}
                  />
                </>
              )}
                <div className="send-btn">
                  {loading ? (
                    <>
                    <SkeletonLoading width={107} height={34} />
                    </>
                  ) : (
                    <>
                      <button
                        type="button"
                        className="btn btn-success fs-12 text-nowrap py-2 btn-small-shadow"
                        onClick={reSendOTP}
                        disabled={isSendCode}
                        style={{minWidth:"70px"}}
                      >
                          {!isSendCode ? "Resend" : (seconds < 10 ? "0"+ seconds : seconds) + "s"}
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="btn-wrap btn-top-space">
              {loading ? (
                <>
                  <SkeletonLoading width={381} height={56} />
                </>
              ) : (
                <>
                  <button type="button" ref={btnRef} className={`btn ${!isVerifyReady?"verify-otp-disabled":"btn-success"}`} disabled={!isVerifyReady} onClick={OnClickVerify}>
                      Verify Email
                  </button>
                </>
              )}
            </div>
          </div>
      </div>
    </>
  );
};

export default VerifyEmail;
